export enum enumWeightUnit {
  KG = 0,
  LB = 1,
}
